export default "__VITE_ASSET__B46rtq$i__"